export const CART_SESSION_KEY = 'cartSession';
export const PREVIOUS_PRODUCT_KEY = 'previousProduct';
export const PREVIOUS_PRODUCT_URL_KEY = 'previousProductUrl';
export const OUT_OF_STOCK_ERROR_KEY = 'checkout_out_of_stock';
export const CHECKOUT_ORDER_PLACED_KEY = 'checkout_order_placed';
export const CHECKOUT_PAYMENT_SUBMITTED_KEY = 'checkout_payment_submitted';

export const PARAM_GUID_QUERY = 'cartGuid';
export const PARAM_ORDER_QUERY = 'orderGuid';
export const PARAM_ORDER_ID_QUERY = 'hybrisOrderId';
export const PARAM_ORDER_CODE_QUERY = 'hybrisOrderCode';
export const PARAM_ID_QUERY = 'cartId';
export const PARAM_PRODUCT_VARIANT_CODE_QUERY = 'variantProductCode';
export const PARAM_TYPE_QUERY = 'type';
export const PARAM_SERVICE_UO_ID_QUERY = 'serviceUoId';
export const PARAM_SERVICE_SO_ID_QUERY = 'serviceSoId';
export const PARAM_SERVICE_UO_TYPE_QUERY = 'UOType';
export const PARAM_GIFTS = 'gifts';
export const DISNEY_PLAN = { STANDARD: 'DISNEY_STANDARD', PREMIUM: 'DISNEY_PREMIUM' } as const;
export const PARAM_DISNEY = 'disney';
export const NETFLIX_PLAN = { STANDARD: 'NETFLIX_STANDARD', PREMIUM: 'NETFLIX_PREMIUM' } as const;
export type NetflixPlanType = (typeof NETFLIX_PLAN)[keyof typeof NETFLIX_PLAN];
export const PARAM_NETFLIX = 'netflix';
export const NETFLIX_UPGRADE_MODAL_KEY = 'netflixUpgradeModal';
export const DISNEY_UPGRADE_MODAL_KEY = 'disneyUpgradeModal';

export const REQUEST_DEBOUNCE_TIMER = 500; // ms
export const INPUT_DEBOUNCE_TIMER = 250; // ms

export const RATE_PLAN_NAME_MANO_200 = 'MANO 200';

export const SPECIAL_DISPLAY_COLORS = {
    WHITE_ARRAY: ['#FFF', '#fff', '#FFFFFF', '#ffffff'],
    TRANSPARENT: '#FFFFFF00',
    MULTICOLOR: '#MULTICOLOR',
};
